<template>
  <div style="">
    <div class="row" v-if="title">
      <div class="col">
          <h5>Map {{ numIndex }}: {{title}}</h5>
      </div>        
    </div>
    <div style="background-color:#f7f7f7;">
      <div class="row">
        <div class="col" v-for="image in images">
          <div class="map-wrap">
            <img v-bind:src="urlForImage(image)" style="width:100%;">
          </div>

        </div>
      </div>
      <div class="row no-gutters" v-if="attribution">
        <p class="attribution">Map: Geofolio. Mountains: GMBA Mountain Inventory v2. Backgrounds: GeoNames, GADM. {{attribution}}</p>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import _ from 'lodash'; 

export default {
    name: 'ImageMap',
    components: { },
    props: ['location', 'source', 'download', 'title', 'description', 'layout', 'attribution', 'factsheet', 'loaded', 'label', 'sublabel', 'images', 'num'],
    data() {
      return {
        numIndex: this.num ? this.num : 'X'
      }
    },
    mounted() {
    },
    watch: {
      location() {
      },
      background() {
      },
      loaded() {
      }
    },
    methods: {
      urlForImage(image) {
        return process.env.VUE_APP_API+'/api/data/factsheet/'+this.factsheet.info.identifier+'/data/'+image.source;
      }
    },
    computed: {
      downloadUrl() {
        if(this.loaded) {
          return process.env.VUE_APP_API+'/api/data/factsheet/'+this.factsheet.info.identifier+'/data/gadm_summary/gadm_level1.geojson';
        }
      }
    }
}
</script>
<style>
</style>

<style scoped>

h4 {
  margin:0px;
  padding:8px;
  padding-left:10px;
  font-size:0.9em;
  width:100%;
  color:#444;
}
h5 {
  font-size:0.7em;
  color:rgb(33, 37, 41);
  font-weight:600;
  padding:12px 0px 8px 0px;
  margin:0px;

}
p {
  margin:0px;
  font-size:0.6em;
  color:#222;
}
p.attribution {
  font-size:0.5em;
  padding:0px 6px 3px 6px;
  color:#888;
}
div.cmd, div.row {
  
}
div.map-wrap {
 background-color:#f5f5f5; 
 border-top:1px solid #ddd;
 border-bottom:1px solid #ddd;
}
a.btn-command:focus, a.btn-command:active {
  outline:none !important;
  box-shadow:none;
} 
a.btn-command {
  background-color:#f5f5f5;
  color:#999;
}
a.btn-command:hover {
  background-color:#eeeeee;
  color:#777;
}
a.btn-command i {
  font-size:0.8em;
}
div.legend-wrapper {
  padding:7px;
}
div.layer-commands {
  margin-top:3px;
  font-size:1em;
}
div.layer-commands a.btn-layer {
  color:#aaa;
}
div.layer-commands a.btn-layer:hover {
  color:#0056b3;
}
.btn:focus,.btn:active {
   outline: none !important;
   box-shadow: none;
}
</style>